import { call, put, select } from 'redux-saga/effects';
import { setMediaSecretKeyCommunication } from '../../../effects/organization';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getMediaSecretKeyCommunication({ payload }) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.V2}/applications/${
    payload.appId
  }/secret?api=MAPI`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.GET,
  });

  if (success && !error) {
    yield put(
      setMediaSecretKeyCommunication({
        appId: payload.appId,
        mediaAppSecret: result.mediaAppSecret,
      }),
    );
  } else {
    console.error(error);
  }
}
